export default __webpack_public_path__ + "static/media/orange-circle-delta.479a5aa5.svg";